import VirtualShop from "./components/VirtualShop";

export default function App() {
	return <VirtualShop />;
}
